import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VContainer,[_c('model-select',{on:{"getCrud":_vm.defineModel}})],1),_c(VContainer,[_c('Create-' + _vm.crudModel,{tag:"component"})],1),_c(VContainer,[_c('List-' + _vm.crudModel,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }